import { render, staticRenderFns } from "./PDragAndDrop.vue?vue&type=template&id=df8af716&scoped=true"
import script from "./PDragAndDrop.vue?vue&type=script&lang=ts"
export * from "./PDragAndDrop.vue?vue&type=script&lang=ts"
import style0 from "./PDragAndDrop.vue?vue&type=style&index=0&id=df8af716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8af716",
  null
  
)

export default component.exports